
import { useMainPageConfig } from '@entities/MainPageConfig'
import { PreviewStories } from '@entities/Stories'

import { MainPageBuilder } from '@features/main-page-builder'

import { BannerApp } from '@widgets/app-banner'

import Container from '@shared/ui/container'
import Wrapper from '@shared/ui/wrapper'

// import { BlogPreview } from "@widgets/blog-preview";
import styles from './styles.module.scss'

export default function MainPage () {
  const { mainPageConfig } = useMainPageConfig()

  return (
    <div className={styles.root}>
      <Container>
        <Wrapper>
          <PreviewStories />
          <MainPageBuilder blocks={mainPageConfig?.blocks} />
          <BannerApp />
        </Wrapper>
      </Container>
    </div>
  )
}